/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE API : TAB : IMAGES STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	image_toggle: {
		width: '100%',
	}, 
	controls: {
        flex: replacePXinStringWithEM('0 0 110px'),
        width: '100%',
        position: 'relative',
        '& .innerControls': {
            '& .field.name-imagetype': {
                display: 'none',
                marginBottom: pxToEm(12) // same as imageTypes
            },
        }
    }
});